import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { supabase } from '../auth/supabaseClient';

const DEFAULT_URL = 'https://localhost:7196/graphql';

const graphqlUrl = process.env.REACT_APP_BACKEND_GRAPHQL_API_URL || DEFAULT_URL;

const httpLink = createHttpLink({ uri: graphqlUrl });

const authLink = setContext(async (_, { headers }) => {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  return {
    headers: {
      ...headers,
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
  };
});

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default apolloClient;
